import type { LinkedItem, RegionGrouping } from "@repo/ui/types/cms/common";

import HeaderLayout from "../HeaderLayout";
import { Features } from "./Features";
import { InternationalDestinations } from "./InternationalDestinations";
import { MobileLinks } from "./MobileLinks";
import { NationalDestinations } from "./NationalDestinations";
import { PriceBanner } from "./PriceBanner";

interface DestinationsProps {
  linkedItems: LinkedItem[];
  title?: string;
  subtitle?: string;
}
export default function Destinations({ linkedItems, title }: Readonly<DestinationsProps>) {
  function categorizeData(data: LinkedItem[]) {
    const [national] = data.filter(
      (item) =>
        Array.isArray(item.region_grouping) &&
        item.region_grouping.some((g: RegionGrouping) => g.codename === "national"),
    );

    const [international] = data.filter(
      (item) =>
        Array.isArray(item.region_grouping) &&
        item.region_grouping.some((g: RegionGrouping) => g.codename === "international"),
    );

    const [multiTextBanner] = data.filter((item) => "multi_text_banner" in item);

    const [iconFeatureCards] = data.filter((item) => "icon_feature_cards" in item);

    return { national, international, multiTextBanner, iconFeatureCards };
  }

  const { national, international, multiTextBanner, iconFeatureCards } =
    categorizeData(linkedItems);

  return (
    <HeaderLayout>
      {multiTextBanner?.multi_text_banner?.[0] && (
        <PriceBanner banner={multiTextBanner.multi_text_banner[0]} />
      )}
      <div className="text-brand-blue container mx-auto" data-testid="destinations-container">
        <div className="mb-2 flex gap-8 justify-between" data-testid="destinations-header">
          <div className="hidden items-center md:flex" data-testid="destinations-title-section">
            {title && (
              <h2
                className="text-brand-blue text-xl font-bold md:text-4xl"
                data-testid="destinations-title-lbl"
              >
                {title}
              </h2>
            )}
          </div>
          {national && (
            <div
              className="hidden min-w-sm flex-row md:flex"
              data-testid="destinations-national-section"
            >
              <NationalDestinations destination={national} />
            </div>
          )}
          <div className="flex justify-center md:hidden" data-testid="destinations-mobile-links">
            <MobileLinks />
          </div>

          {international && (
            <div
              className="flex min-w-xl flex-row justify-center"
              data-testid="destinations-international-section"
            >
              <InternationalDestinations destination={international} />
            </div>
          )}
        </div>
      </div>
      <Features features={iconFeatureCards?.icon_feature_cards || []} />
    </HeaderLayout>
  );
}
